import React, { forwardRef, useState,useRef,useEffect } from "react";
// import ContentEditable from "react-contenteditable";

const Editable = forwardRef((props, ref) => {
  const wrapperRef=useRef(null)
  const { values, setValues } = props;
  const { project_name, name } = values;
  const [showInput, setShowInput] = useState(false);

  // const handleChange = (e) => {
  //   if (e.target.value === "<br>")
  //     setValues({
  //       ...values,
  //       [param]: "",
  //     });
  //   else {
  //     const specialCharRegex = /[^a-zA-Z0-9\s]/g; // Allow letters, numbers, and spaces only

  //     // Get the current content and remove special characters
  //     const sanitizedContent = e.target.value.replace(specialCharRegex, "");
  //     const truncatedHtml = sanitizedContent.substring(0, 30);
  //     setValues({
  //       ...values,
  //       [param]: truncatedHtml,
  //     });
  //   }
  // };

  //   const handlePaste = (e) => {
  //   e.preventDefault();
  //   const text = e.clipboardData.getData("text/plain");
  //   // Only plain text allowed
  //   const sanitized = text.replace(/[^a-zA-Z0-9\s]/g, "").substring(0, 30);

  //   // Insert into values
  //   setValues({
  //     ...values,
  //     [param]: sanitized,
  //   });
  // };

   // Detect click outside input
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowInput(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const allowedChars = /^[a-zA-Z0-9\s]*$/;

  const handleBeforeInput = (e) => {
    if (!allowedChars.test(e.data)) {
      e.preventDefault(); // Block invalid input before it's shown
    }
  };

  const handleChange = (e) => {
    let {value,name} = e.target;
   if (value.trim() === "") {
      value = "";
    } else {
      value = value.trimStart(); // or use .trim() to trim both ends
    }
    setValues({
      ...values,
      [name]: value,
    });
  };

  return (
    <>
      {/* <ContentEditable
      className={className}
      innerRef={ref}
      html={values[param]} // innerHTML of the editable div
      onKeyDown={(e) => {
        if (e.key === "Enter" || (!ref.current.textContent && e.key === " ")) {
          e.preventDefault();
        }
      }}
      onPaste={handlePaste}
      onChange={handleChange} // handle innerHTML change
      tagName="article" // Use a custom HTML tag (uses a div by default)
    /> */}
      <div className="editable" ref={wrapperRef}>
        {showInput || !project_name || !name ? (
          <>
            <input
              name="project_name"
              placeholder={"Enter Project Name"}
              className={
                "text-[#0D6666] project_name cursor-text font-semibold text-base border-b-2 border-red-500 mr-1 max-w-[152px]"
              }
              onChange={handleChange}
              maxLength="20"
              onBeforeInput={handleBeforeInput}
              onFocus={() => setShowInput(true)}
              value={project_name}
            />
           <span>/</span> 
            <input
              name="name"
              placeholder={"Enter Design Name"}
              className={
                "project_name cursor-text font-semibold text-base border-b-2 border-red-500 ml-1 max-w-[152px]"
              }
              onChange={handleChange}
              maxLength="20"
              onBeforeInput={handleBeforeInput}
              onFocus={() => setShowInput(true)}
              value={name}
            />
          </>
        ) : (
          <div onClick={() => setShowInput(true)}>
            <span className="txtBlue mr-1" >{project_name}</span >/<span className="ml-1">{name}</span>
          </div>
        )}
      </div>
    </>
  );
});

export default Editable;
